import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../_service/message-service';
import { AuthenticationService, UserService } from 'src/app/_services';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
export interface miscTransactions {
  userId: number;
  date: string;
  amount: string;
  time: string;
  operation: string;
  balance: string;
  details: string;
  transactionId: any;
}
@Component({
  selector: 'telio-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {
  transid;
  walletDetails;
  walletAmount: number
  MobileUser;
  amount;
  transactionId;
  transId;
  counter: number = 0;
  PaymentDate: any = [];
  description;
  netAmount;
  igst;
  formdetails;
  updateForm: UntypedFormGroup;
  userId;
  rs;

  constructor(private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    readonly route: ActivatedRoute,
    private toastr: SnackbarService,
    readonly exportCSVService: ExportCSVService,
    public translate: TranslateService,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.transid = params['userId']
      this.MobileUser= params['mobileUser']
      this.userId =params['userId']
    })
    this.userService.getWalletAmount(this.userId).subscribe((resp: any) => {
      this.walletDetails = resp;
      this.walletAmount = +this.walletDetails.balance
    })
    this.updateForm = this.formBuilder.group({
      description: [null, Validators.required],
      counter: [null, Validators.required]
    })
    let localInfo = this.authenticationService.getlocalInfo.subscribe(local => {
      this.rs = local ? local.currencySymbol : this.translate.instant('rs');
    });

  }

  updateWallet() {
    if (!this.updateForm.valid) {
    }
    this.formdetails = this.updateForm.value;
    let counterAmount = +this.formdetails.counter;
    let updatedAmount = + (this.walletAmount + counterAmount)

    if (this.formdetails.counter === null) {
      this.toastr.error(this.translate.instant('transactions.amountError1'))
    }
    if (this.formdetails.description == null) {
      this.toastr.error(this.translate.instant('transactions.descriptionError'))
      return
    }
    if (updatedAmount < 0) {
      this.toastr.error(this.translate.instant('transactions.walletError'))
      return
    }
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const formData = new FormData();
    formData.append('userId', this.transid);
    formData.append('amount', this.formdetails.counter);
    formData.append('description', this.formdetails.description)
    let input: any = {
      'user_id': this.transid,
      'amount': this.formdetails.counter,
      'description': this.formdetails.description
    }
    this.userService.updateWallet(input).subscribe((resp: any) => {
      if (resp != null) {
        this.toastr.success(resp);
        this.router.navigate(["/dashboard/wallets", { routeID: this.route.snapshot.paramMap.get('routeID') }]);
      }
      else {
        this.toastr.error(this.translate.instant('transactions.walletFail'))
      }
    },
      error => {
        this.toastr.error(error)
      }
    )
  }

  closewallet() {
    this.updateForm.markAsPristine();
    this.updateForm.markAsUntouched();
    this.updateForm.controls['description'].reset()
    this.updateForm.controls['counter'].reset()
  }

  back() {
    this.router.navigate(["/dashboard/wallets", { routeID: this.route.snapshot.paramMap.get('routeID') }])
  }
}
